/* eslint-disable no-unused-vars */
import BaseService from './base.service'
import { ENDPOINT } from '~/api/endpoint'

class SettingService extends BaseService {
  constructor(option) {
    super(option)
    return this
  }

  /* Danh sách bệnh nhân */
  getSetting() {
    return this.http.get(ENDPOINT.SETTING_DETAIL)
      .then(res => res.data.data)
  }

  /* Cập nhật vị thuốc */
  updateSetting(data) {
    return this.http.put(ENDPOINT.SETTING_UPDATE, { data })
  }
}

export default new SettingService({ auth: true })
